import { faRedoAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "reactstrap";
import "./index.scss";
const ResetSearch = ({ className = '', label = 'View More', loading = false, __resetSearch }) => {

	return (
		<>
			<div className={`reset-blc ${className}`}>
				<Button onClick={() => __resetSearch()} color="link">
					{label}
					<span className="icon">
						<FontAwesomeIcon icon={faRedoAlt} />
					</span>
				</Button>
			</div>
		</>
	);

}

export default ResetSearch;